import styled from "styled-components";

export const EmptyPageWrap = styled.section`
	width: 100%;
	max-width: 100%;
	box-sizing: border-box;
	.img {
		width: 13.125rem;
		display: block;
		margin: 4.375rem auto 0 auto;
	}
	.text {
		box-sizing: border-box;
		width: 100%;
		padding: 0 1.5625rem;
		color: #999;
		font-size: 0.75rem;
		font-family: "SFProText-Regular";
		font-weight: 400;
		line-height: 1.3125rem;
		text-align: center;
		word-wrap: break-word;
	}
	.btn {
		margin: 2rem auto;
		color: #fff;
		background-color: #e33023;
		min-width: 11.25rem;
		width: fit-content;
		height: 2.5rem;
		padding: 0 1rem;
		border-radius: 2px;
		text-align: center;
		line-height: 2.5rem;
	}
`;
